import { render, staticRenderFns } from "./objetivos-definidos.vue?vue&type=template&id=56ef924a&scoped=true&"
import script from "./objetivos-definidos.vue?vue&type=script&lang=js&"
export * from "./objetivos-definidos.vue?vue&type=script&lang=js&"
import style0 from "./objetivos-definidos.vue?vue&type=style&index=0&id=56ef924a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef924a",
  null
  
)

export default component.exports